__turbopack_context__.v({
  "brandRow": "_9tGfhG_brandRow",
  "content": "_9tGfhG_content",
  "ctaRow": "_9tGfhG_ctaRow",
  "divider": "_9tGfhG_divider",
  "heroBuyNowButton": "_9tGfhG_heroBuyNowButton",
  "heroSection": "_9tGfhG_heroSection",
  "leftContent": "_9tGfhG_leftContent",
  "title": "_9tGfhG_title",
  "titleLine": "_9tGfhG_titleLine",
  "uhLogoType": "_9tGfhG_uhLogoType",
});
